import React from "react";
import { Col } from "../Grid";

const PageNavbarSearchMain = ({ ...props }) => {
	return <Col md={9} {...props} />;
};

export default PageNavbarSearchMain;
